import React from 'react';
import { styles } from './CategoryCard.css';
import { Link } from '../../../PlatformFunctionality';

export interface CategoryCardProps {
  title: string;
  icon: React.ReactNode;
  url: string;
}

export const CategoryCard = ({ title, icon, url }: CategoryCardProps) => {
  return (
    <Link className={styles.container} href={url}>
      <div className={styles.icon}>{icon}</div>
      <span className={styles.title}>{title}</span>
    </Link>
  );
};
